module.exports = __webpack_public_path__ + "img/81000.4f14b43f.jpg";